import { CSSProperties } from 'react';
import styled from 'styled-components';

import { BodilColor } from '~src/branding';
import { Heading, Text } from '~src/components/Typography';
import { useDisplay } from '~src/hooks/useDisplay';
import { HeatPumpOutdoorUnit, SolarPanel } from '~src/model';

import { ProductImage } from './ProductImage';

const ProductBannerShading = styled.div({
  position: 'absolute',
  background: BodilColor.contrast.almond,
  opacity: 0.2,
  left: 0,
  bottom: 0,
  height: '100%',
  width: '100%',
});

type ProductDescriptionProps = {
  style?: CSSProperties;
  solarPanel?: Pick<SolarPanel, 'brand' | 'imageUrl'>;
  heatPump?: Pick<HeatPumpOutdoorUnit, 'brand' | 'imageUrl'>;
};

export const ProductDescription = ({ solarPanel, heatPump, style }: ProductDescriptionProps) => {
  const { isMobile } = useDisplay();

  const products = [
    ...(solarPanel ? [`${solarPanel.brand} solceller`] : []),
    ...(heatPump ? [`en ${heatPump.brand} varmepumpe`] : []),
  ];

  if (products.length === 0) {
    return null;
  }

  const formattedProducts = products.join(' og ');

  const isCombined = products.length > 1;

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        ...(isMobile ? { paddingBottom: '24px' } : { height: '180px' }),
        ...style,
      }}
    >
      <ProductBannerShading />

      <div style={{ height: '100%', width: isCombined && isMobile ? '100%' : '50%' }}>
        <Heading style={{ marginTop: '32px' }} color='light'>
          Bodil foreslår
        </Heading>

        <Text
          style={{ lineHeight: '20px', width: isMobile ? '100%' : '300px', marginTop: '8px' }}
          level={2}
          color='light'
        >
          Ud fra vores sortiment forslår vi {formattedProducts} til din bolig. Book tid til rådgivning for at høre om
          vores andre modeller.
        </Text>
      </div>

      <ProductImage heatPumpImage={heatPump?.imageUrl} solarImage={solarPanel?.imageUrl} />
    </div>
  );
};
